import React from 'react';
import ReactSelect from 'react-select';

import {FieldProp, ChainedSelectInput, Choice, Field} from '../../types';
import {DisplayOnly} from './DisplayOnly';
import {FormState} from '../Form';
import {fieldValueText} from '../../_helpers/form';

type ChainedSelectProps = FieldProp & {};

export const ChainedSelect: React.FunctionComponent<ChainedSelectProps> = ({
                                                                               form,
                                                                               field,
                                                                               fieldState,
                                                                               onChange,
                                                                               onBlur,
                                                                               value,
                                                                               displayOnly,
                                                                               formState,
                                                                           }): JSX.Element => {
    const fieldValue = value || {};

    const {
        touched,
        pristine,
        validating,
        valid,
        invalid,
        errors,
    } = fieldState;
    const classNames = [
        /* 'form-control', */
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
        field.chainedSelectsAlignment === 'horizontal' && 'col',
        field.chainedSelectsAlignment === 'vertical' && 'col-12',
    ]
        .filter(Boolean)
        .join(' ');

    const rowClassNames = [
        'row',
        field.chainedSelectsAlignment === 'horizontal' && !displayOnly && 'no-gutters'
    ]
        .filter(Boolean)
        .join(' ');

    const filterOptions = (fieldValue: any) => (item: Choice) => {
        // if item doesnt have a dependency, then it is always available
        if (item.hasOwnProperty('dependency') && item.dependency?.field) {
            return (
                fieldValue.hasOwnProperty(item.dependency.field) &&
                fieldValue[item.dependency.field] !== null &&
                fieldValue[item.dependency.field].value === item.dependency.value
            );
        }
        return true;
    };

    const advancedFilter = (formState: FormState | undefined, field: Field, input: ChainedSelectInput, fieldValue: any) => {
        if (field?.flowCustomDisplayComponentConfig?.filterFunction) {
            return (item: Choice) => {
                let result = false;
                try {
                    result = eval(field.flowCustomDisplayComponentConfig.filterFunction);
                } catch (e) {
                    console.log('Exception', e);
                    result = false;
                }
                return result;
            };
        } else {
            return () => true;
        }
    };

    return (
        <div className={rowClassNames}>
            {displayOnly ?
                <DisplayOnly>
                    {Object.keys(fieldValue).map((key: string, index: number) => {
                        const input = field.inputs.find((input: ChainedSelectInput) => input.id === key);
                        return (
                            <div key={index} className="col">
                                <strong className="pr-2">{input.label}:</strong>
                                {fieldValue[key]?.text}
                            </div>
                        );
                    })}
                </DisplayOnly>
                :
                [

                    field.inputs.map((input: ChainedSelectInput, index: number) => {
                        // @ts-ignore
                        const options: any = field.choices[input.id as any]
                            .filter(filterOptions(fieldValue))
                            .filter(advancedFilter(formState, field, input, fieldValue));

                        // if this is NOT the first dropdown and there is only 1 choice, auto-select
                        if (options.length === 1 && index > 0) {
                            fieldValue[input.id] = options[0];
                        }

                        // we are on the first field and a preFilterByField value is set
                        // grab the text value from that filerByField and attempt to select
                        // the first option that matches that value
                        if (index === 0 && field?.flowCustomDisplayComponentConfig?.preFilterByField) {
                            const preFilterValue = formState ? fieldValueText(formState, form, field.flowCustomDisplayComponentConfig.preFilterByField) : '';
                            const preFilterOption = options.find((option: Option) => option.value === preFilterValue);
                            fieldValue[input.id] = preFilterOption ? preFilterOption : null;
                        }

                        const selectClasses = [
                            classNames,
                            field?.flowCustomDisplayComponentConfig?.hideInputs?.includes(index) && 'invisible'
                        ].filter(Boolean).join(' ');

                        return (
                            <ReactSelect
                                style={{width: '100%'}}
                                key={input.id}
                                id={input.id}
                                required={field.isRequired}
                                className={selectClasses}
                                onChange={(option: any) => {
                                    let newState: any = {
                                        ...fieldValue,
                                        [input.id]: option
                                    };

                                    // confirm that the other selections are still valid
                                    // foreach of the props in newState, get list of valid options
                                    // if current value in state doesn't exist in valid options, null it
                                    Object.keys(newState).forEach((key: string) => {
                                        if (key !== input.id) {
                                            newState[key] = (
                                                field.choices[key as any]
                                                    .filter(filterOptions(newState))
                                                    .find((item: any) => (
                                                        newState.hasOwnProperty(key) &&
                                                        newState[key] !== null &&
                                                        item.value === newState[key].value
                                                    )) !== undefined
                                            ) ? newState[key] : null;
                                        }
                                    });

                                    onChange && onChange(newState);

                                    // React-Select on mobile fires onChange and onBlur simultaneously, onBlur depends on the value of the select having
                                    // been set. To fix, call onBlur with currently selected option after onChange
                                    setTimeout(() => {
                                        onBlur && onBlur({[field.name]: newState});
                                    }, 2);
                                }}
                                onBlur={() => {
                                    // React-Select on mobile fired onChange and onBlur simulatenously, onBlur depends on the value of the select having
                                    // been set. To fix, call onBlur with currently selected option after onChange
                                    //onBlur && onBlur()
                                }}
                                value={fieldValue[input.id]}
                                defaultValue={fieldValue[input.id]}
                                placeholder={input.label}
                                options={options}
                                isDisabled={field.gwreadonly_enable}
                            />
                        )
                    })
                    ,
                    errors && errors.map((error: string, index: number) => (
                        <div key={index} className="col-12 invalid-feedback">
                            {error}
                        </div>
                    ))
                ]
            }
        </div>
    );
};